<template>
  <div>
    <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-text-field
      solo
      label="Search"
      clearable
      prepend-inner-icon="search"
      @keyup.enter="doSearch"
      @click:clear="doClear"
      v-model="search"
    ></v-text-field>

    <v-dialog v-model="dialog.Detail" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Form Pencairan Dana</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="UnitsDetail.id_mst_bank"
                  :items="MstBank"
                  label="Nama Bank"
                  item-text="bank_name"
                  item-value="id"
                  required
                ></v-autocomplete
              ></v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="UnitsDetail.nama_rekening"
                  label="Nama Rekening"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4"
                ><v-text-field
                  v-model="UnitsDetail.nomor_rekening"
                  label="Nomor Rekening"
                  required
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-row v-if="StatusPencairan.simotor">
                <v-col cols="12" md="6">
                  <viewer :images="images">
                    <img
                      :src="$url_img + UnitsDetail.photo_bukti_simotor"
                      width="150"
                      height="150"
                    />
                    <h5>Bukti Simotor</h5>
                  </viewer>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="12" md="6">
                  <v-img
                    :src="URLFoto.simotor"
                    max-height="300"
                    max-width="300"
                  >
                    <v-row align="end" class="fill-height">
                      <v-col>
                        <v-file-input
                          dense
                          outlined
                          background-color="#ffeeee"
                          prepend-icon=""
                          v-model="Foto.simotor"
                          label="Bukti Pembayaran Simotor"
                          show-size
                          accept="image/*"
                          counter
                          @click:clear="ClearFileSimotor"
                          @change="changeFileSimotor"
                        >
                        </v-file-input>
                      </v-col> </v-row
                  ></v-img>
                </v-col>

                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="UnitsDetail.pencairan_simotor"
                    label="Transfer Ke Simotor ?"
                    required
                  ></v-checkbox
                ></v-col>
              </v-row>

              <v-row v-if="StatusPencairan.penjual">
                <v-col cols="12" md="6">
                  <viewer :images="images">
                    <img
                      :src="$url_img + UnitsDetail.photo_bukti_penjual"
                      width="150"
                      height="150"
                    />
                    <h5>Bukti Penjual</h5>
                  </viewer>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="12" md="6">
                  <v-img
                    :src="URLFoto.penjual"
                    max-height="300"
                    max-width="300"
                  >
                    <v-row align="end" class="fill-height">
                      <v-col>
                        <v-file-input
                          dense
                          outlined
                          background-color="#ffeeee"
                          prepend-icon=""
                          v-model="Foto.penjual"
                          label="Bukti Pembayaran Penjual"
                          show-size
                          accept="image/*"
                          counter
                          @click:clear="ClearFilePenjual"
                          @change="changeFilePenjual"
                        >
                        </v-file-input>
                      </v-col> </v-row
                  ></v-img>
                </v-col>

                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="UnitsDetail.pencairan_penjual"
                    label="Transfer Ke Penjual ?"
                    required
                  ></v-checkbox
                ></v-col>
              </v-row>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog.Detail = false"
            >Close</v-btn
          >
          <v-btn
            v-if="
              StatusPencairan.simotor == false &&
                StatusPencairan.penjual == false
            "
            color="blue darken-1"
            text
            @click="OnKonfirmasi"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tabs v-model="tab" fixed-tabs>
      <v-tab>
        <v-badge
          v-if="Pencairan.count != 0"
          color="pink"
          :content="Pencairan.count"
          >Pencairan</v-badge
        >
        <div v-else>Pencairan</div>
      </v-tab>
      <v-tab>Selesai</v-tab>
    </v-tabs>

    <v-tabs-items v-if="RenderUnits" v-model="tab">
      <v-tab-item>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page.Pencairan"
            @input="GetPencairan()"
            :length="lengthPage.Pencairan"
            :total-visible="7"
          ></v-pagination>
        </div>
        <TransferDana :units="Pencairan" :onDetail="GetUnitDetail" />
      </v-tab-item>
      <v-tab-item>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page.PencairanSelesai"
            @input="GetPencairanSelesai()"
            :length="lengthPage.PencairanSelesai"
            :total-visible="7"
          ></v-pagination>
        </div>
        <TransferDana :units="PencairanSelesai" :onDetail="GetUnitDetail" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import TransferDana from '@/components/TransferDana.vue';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';

Vue.use(Viewer);
export default {
  components: {
    TransferDana
  },
  data() {
    return {
      todayDate: null,
      Foto: { simotor: [], penjual: [] },
      URLFoto: { simotor: '', penjual: '' },
      StatusPencairan: { simotor: false, penjual: false },
      RenderUnits: true,
      tab: null,
      selected_mst_bank: null,
      color: { snackbar: '' },
      snackbar: false,
      message: null,
      Alasan: [],
      images: [],
      DetailData: [],
      UnitsDetail: [],
      dialog: { Detail: false, Terima: false },
      MstBank: null,

      Pencairan: [],
      PencairanSelesai: [],
      search: null,
      rekening: { nama: '', nomor: '' },
      page: { PencairanSelesai: 1, Pencairan: 1 },
      lengthPage: { PencairanSelesai: 0, Pencairan: 0 },
      limit: 9,
      offset: 0,
      users: []
    };
  },
  mounted() {
    this.GetPencairan();
    this.GetPencairanSelesai();
  },
  created() {
    let users = localStorage.getItem('user');
    this.users = JSON.parse(users);

    this.GetMstBank();
  },
  methods: {
    changeFileSimotor() {
      this.URLFoto.simotor = URL.createObjectURL(this.Foto.simotor);
    },
    changeFilePenjual() {
      this.URLFoto.penjual = URL.createObjectURL(this.Foto.penjual);
    },
    ClearFileSimotor() {
      this.Foto.simotor = null;
    },
    ClearFilePenjual() {
      this.Foto.penjual = null;
    },
    forceRerender() {
      this.RenderUnits = false;
      this.$nextTick(() => {
        this.RenderUnits = true;
      });
    },
    async Reload() {
      this.GetPencairan();
      this.GetPencairanSelesai();
      this.forceRerender();
    },
    doClear() {
      this.GetPencairan();
      this.GetPencairanSelesai();
    },
    doSearch() {
      this.GetPencairan();
      this.GetPencairanSelesai();
    },
    async GetUnitDetail(id) {
      this.Foto == null;
      this.UnitsDetail == '';
      this.DetailData == [];
      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v3/reimburs_detail', {
          params: {
            id: id,
            limit: 1
          }
        })
        .then(response => {
          this.UnitsDetail = response.data.data[0];
          this.dialog.Detail = true;
        })
        .catch(error => {
          this.snackbar = true;
          this.color.snackbar = 'red';
          this.message = error;
        });
      this.StatusPencairan.simotor = this.UnitsDetail.pencairan_simotor;
      this.StatusPencairan.penjual = this.UnitsDetail.pencairan_penjual;
    },

    go() {
      var offset = (this.offset = (this.page - 1) * this.limit);
      console.log(offset);
    },

    async GetPencairan() {
      var offset = (this.offset = (this.page.Pencairan - 1) * this.limit);

      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v3/reimburs', {
          params: {
            search: this.search,
            offset: offset,
            limit: this.limit
          }
        })
        .then(response => {
          this.Pencairan = response.data;
          var mod = this.Pencairan.count % this.limit;
          this.lengthPage.Pencairan =
            (this.Pencairan.count - mod) / this.limit + 1;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async GetPencairanSelesai() {
      var offset = (this.offset =
        (this.page.PencairanSelesai - 1) * this.limit);

      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v3/reimburs', {
          params: {
            search: this.search,
            offset: offset,
            limit: this.limit,
            pencairan_simotor: true,
            pencairan_penjual: true
          }
        })
        .then(response => {
          this.PencairanSelesai = response.data;
          var mod = this.PencairanSelesai.count % this.limit;
          this.lengthPage.PencairanSelesai =
            (this.PencairanSelesai.count - mod) / this.limit;
        })
        .catch(error => {
          console.log(error);
        });
    },

    async GetMstBank() {
      this.MstBank = null;
      const bank = await this.$req.get(this.$root.$baseapi.master+'/master/v3/mst_bank');

      this.MstBank = bank.data.data;
    },

    async OnKonfirmasi() {
      this.Alasan = 'Unit Berhasil diModerasi';
      let formData = new FormData();
      formData.append('id_iklan', this.UnitsDetail.id_iklan);
      formData.append('pencairan_penjual', this.UnitsDetail.pencairan_penjual);
      formData.append('pencairan_simotor', this.UnitsDetail.pencairan_simotor);
      formData.append('nama_rekening', this.UnitsDetail.nama_rekening);
      formData.append('nomor_rekening', this.UnitsDetail.nomor_rekening);
      formData.append('id_mst_bank', this.UnitsDetail.id_mst_bank);
      formData.append('id_app_user', this.UnitsDetail.id_app_user);
      formData.append('photo_bukti_penjual', this.Foto.penjual);
      formData.append('photo_bukti_simotor', this.Foto.simotor);

      const response = await this.$req
        .post(this.$root.$baseapi.transaksi+'/transaksi/v3/reimburs', formData)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.snackbar = true;
          this.color.snackbar = 'red';
          this.message = error;
        });

      this.dialog.Detail = false;
      this.snackbar = true;
      this.message = response.data.api_message;
      this.color.snackbar = 'success';
      this.UnitsDetail == [];
      this.Foto == null;

      this.Reload();
    }
  },
  computed: {}
};
</script>
